import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';

import Author from './Author';
import SecureFileGrid from '../secureStorage/SecureFileGrid';

const MessageBubble = (props) => {
  const {
    fullName,
    timestampLabel,
    messageText,
    files,
    isOwn,
    showAuthorRow,
  } = props;

  return (
    <Stack alignItems={isOwn ? 'flex-end' : 'flex-start'}>
      <Box
        sx={{
          maxWidth: '88%',
          border: '1px solid',
          borderColor: isOwn ? '#F2B69E' : '#ECECF1',
          borderRadius: '9px',
          backgroundColor: isOwn ? '#FFF4EE' : '#FFFFFF',
          p: '10px 13px',
        }}
      >
        <Stack sx={{gap: 0.5}}>
          {
            showAuthorRow ?
              <Author
                fullName={fullName}
                timestampLabel={timestampLabel || ''}
                nameSx={{fontSize: '11px', fontWeight: 700, color: '#63708A'}}
              /> :
              <Typography sx={{fontSize: '11px', fontWeight: 700, color: '#63708A'}}>
                {fullName}
              </Typography>
          }
          {
            messageText &&
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 400,
                  color: '#050A14',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {messageText}
              </Typography>
          }
          {
            Array.isArray(files) && files.length > 0 &&
              <SecureFileGrid files={files} />
          }
          {
            !showAuthorRow && timestampLabel &&
              <Typography
                sx={{
                  fontSize: '11px',
                  fontWeight: 400,
                  color: '#9A9BAE',
                }}
              >
                {timestampLabel}
              </Typography>
          }
        </Stack>
      </Box>
    </Stack>
  );
};

MessageBubble.propTypes = {
  fullName: PropTypes.string.isRequired,
  timestampLabel: PropTypes.string,
  messageText: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.object),
  isOwn: PropTypes.bool,
  showAuthorRow: PropTypes.bool,
};

export default React.memo(MessageBubble);
